// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"175":"44c0ef47","233":"ca05d158","369":"b812b650","936":"f5a90d91"}[chunkId] + ".css";
};